import * as React from 'react';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';

export default function FeedbackForm(props) {
  return (
  <Paper elevation={3} sx={{ padding: 2 }}>
      <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>

        <Box
          component="main"
          sx={(theme) => ({
            flexGrow: 1,
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflow: 'auto',
          })}
        >
          <Stack
            spacing={2}
            sx={{
              alignItems: 'center',
              mx: 3,
              pb: 5,
              mt: { xs: 8, md: 0 },
            }}
          >
            <Typography variant="body1" sx={{ mb: 2 }}>
              Hello! We appreciate your feedback on the Rocket Offer app! Please answer the following questions to help us improve your experience.
            </Typography>
            <Stack spacing={2} sx={{ width: '100%', maxWidth: 800 }}>
              <Typography variant="body2">
                1. What were you trying to accomplish when the issue occurred?
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                multiline
                rows={2}
              />
              <Typography variant="body2">
                2. Can you describe the issue in detail?
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                multiline
                rows={3}
              />
              <Typography variant="body2">
                3. When did the issue occur? (e.g., date, time, or specific situation)
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
              />
              <Typography variant="body2">
                4. Have you encountered this issue before? If yes, how often does it happen?
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                multiline
                rows={2}
              />
              <Typography variant="body2">
                5. Do you have any suggestions for how we can address this issue or improve the app?
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                multiline
                rows={3}
              />
              <Button
                variant="contained"
                sx={{ mt: 2 }}
                onClick={() => alert('Thank you for your feedback!')}
              >
                Submit
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Box>
    </Paper>
  );
}
